module.exports = __webpack_public_path__ + "img/btn2@2x.caaa5a0c.png";